<script lang="ts">
	import arrowRight from '$lib/assets/images/icons/arrow-right.svg';
	import mailOutline from '$lib/assets/images/icons/mail-outline.svg';
	import phoneOutline from '$lib/assets/images/icons/phone-outline.svg';
	import __ from '$lib/stores/TranslationStore';
</script>

<div class="bg-primary">
	<div class="container mx-auto !overflow-visible py-16">
		<div class="items-top mx-auto flex h-full flex-col justify-center gap-6 md:flex-row 2xl:gap-12">
			<div class="lg:order-1 lg:w-full">
				<div class="max-w-sm">
					<a
						href="https://g.page/r/CYJQLFbl9TTpEBI/review"
						target="_blank"
						rel="noreferrer"
						class="mb-4 flex items-center gap-3 text-xs font-semibold uppercase tracking-0.14 text-light lg:text-lg"
					>
						{$__('Avaliar no Google')}
						<img src={arrowRight} alt="avaliar" />
					</a>
					<h3 class="text-4xl text-light lg:text-5xl lg:leading-54">
						{$__('Mostramos-lhe o caminho até a melhor solução')}
					</h3>
					<h4 class="mt-7 text-lg font-light text-light lg:mb-16 lg:text-xl">
						{$__('Pode nos encontrar na morada:')}<br />
						Rua Dr. José Joaquim de Almeida 2, 3E, 2780-322 Oeiras
					</h4>
					<div class="mt-4 text-sm font-light text-light md:text-lg">
						<div class="flex items-center gap-3 border-b border-light py-4">
							<img src={mailOutline} alt="" />
							<!--Subject : contacto via website-->
							<a href="mailto:info@poupancanominuto.com">info@poupancanominuto.com</a>
						</div>
						<div class="flex items-center gap-3 border-b border-light py-4">
							<img src={phoneOutline} alt="" />
							<a
								on:click={() => window.gtag('event', 'Click', { event_category: 'Click To Call' })}
								href="tel:+351 211 453 334"
							>
								+351 211 453 334
							</a>
						</div>
					</div>
				</div>
			</div>
			<div class="relative w-full">
				<iframe
					title="Morada"
					class="-top-60 left-0 max-w-full rounded-2xl lg:absolute lg:max-w-md"
					src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3114.3968124535313!2d-9.3111555!3d38.685728399999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ec974b46425a9%3A0xe934f5e5562c5082!2sPoupan%C3%A7a%20no%20Minuto!5e0!3m2!1sen!2spt!4v1678113234814!5m2!1sen!2spt"
					width="550"
					height="750"
					loading="lazy"
					referrerpolicy="no-referrer-when-downgrade"
				/>
			</div>
		</div>
	</div>
</div>
